import { render, staticRenderFns } from "./TermsAgency.vue?vue&type=template&id=43806e4f&scoped=true&"
import script from "./TermsAgency.vue?vue&type=script&lang=js&"
export * from "./TermsAgency.vue?vue&type=script&lang=js&"
import style0 from "./TermsAgency.vue?vue&type=style&index=0&id=43806e4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43806e4f",
  null
  
)

export default component.exports